<app-modal
  *ngIf="mainContent && secondaryAction && primaryAction"
  [modalTitle]="'general.investmentQualification'"
  [mainContentTemplate]="mainContent"
  [secondaryActionTemplate]="secondaryAction"
  [primaryActionTemplate]="primaryAction"
  (closed)="activeModal.dismiss()"
></app-modal>

<ng-template #mainContent>
  <label class="mb-2"
    >{{
      "registrationWizard.investorRatingModal.experienced.expDecription"
        | translate
    }}
  </label>
  <label class="mb-0"
    >{{
      "registrationWizard.investorRatingModal.experienced.expConfirmation"
        | translate
    }}
  </label>
</ng-template>

<ng-template #secondaryAction>
  <button
    class="btn btn-falcon-default btn-sm me-3"
    type="button"
    (click)="handleSecondaryAction()"
  >
    {{ "general.no" | translate }}
  </button>
</ng-template>

<ng-template #primaryAction>
  <button
    class="btn btn-primary btn-sm"
    type="submit"
    (click)="handlePrimaryAction()"
  >
    {{ "general.yes" | translate
    }}<span class="ms-2" data-fa-transform="shrink-3"> </span>
  </button>
</ng-template>
